module.exports = __webpack_public_path__ + "img/SwissLife.024c82f3.png";